const invoicing = {
  fr: {
    invoicing: {
      pageTitle: 'Facturation',
      selectARadio: 'Sélectionnez une radio',
      campaignsTotal: 'Total campagnes',
      salesCommissionsTotal: 'Total commissions',
      costPerSpot: '{{value}} par spot',
      noInvoiceThisMonth: 'Aucune facture ce mois-ci',
      billed: 'Facturée',
      playedSpots: '{{count}} joués',
    },
  },
  en: {
    invoicing: {
      pageTitle: 'Invoicing',
      selectARadio: 'Pick a radio',
      campaignsTotal: 'Campaigns total',
      salesCommissionsTotal: 'Commissions total',
      costPerSpot: '{{value}} per spot',
      noInvoiceThisMonth: 'No invoice this month',
      billed: 'Billed',
      playedSpots: '{{count}} played',
    },
  },
};

export default invoicing;



// WEBPACK FOOTER //
// ./src/statsradio/modules/billing/i18n/invoicing.js